<template>
  <div v-wechat-title="title" style="height:100%">
    {{title}}
  </div>
</template>
<script>
export default {
    name: `RecoveryToday`,
    props: {

    },
    data() {
        return {
            title: `今日完成苏醒`
        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Recovery/Today.vue